/**
 * Auth API - unified with Laravel backend (booking.rogersounds.com / localhost:8000)
 * Uses credentials for cookie-based Sanctum auth
 */
import { getBackendOrigin } from "../config/apiBase";

const getAuthBase = () => getBackendOrigin();

const getCsrfToken = () => {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

const authFetch = (path, options = {}) => {
  const base = getAuthBase();
  const url = `${base}${path.startsWith('/') ? path : '/' + path}`;
  const headers = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    ...options.headers,
  };
  if (options.method !== 'GET' && options.method !== 'HEAD') {
    headers['Content-Type'] = 'application/json';
    const token = getCsrfToken();
    if (token) headers['X-XSRF-TOKEN'] = token;
  }
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers,
  });
};

export const getCsrfCookie = () =>
  authFetch('/sanctum/csrf-cookie', { method: 'GET' });

export const login = async (email, password) => {
  await getCsrfCookie();
  const res = await authFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.email || 'Помилка входу');
  return data;
};

export const register = async (userData) => {
  await getCsrfCookie();
  const res = await authFetch('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify(userData),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Помилка реєстрації');
  return data;
};

export const logout = async () => {
  try {
    await authFetch('/api/auth/logout', { method: 'POST' });
  } catch (e) {
    // ignore
  }
};

export const getMe = async () => {
  const res = await authFetch('/api/user/me');
  if (!res.ok) return null;
  const data = await res.json();
  return data.user || null;
};

export const forgotPassword = async (email) => {
  await getCsrfCookie();
  const res = await authFetch('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.email || data.message || 'Помилка');
  return data;
};
